export class User {
    userId : any;
    userRole : any;
    featureId : any;
    cretedOn : any;
    password : any;
    email : any;
    name : any;
    privilege : any;
    lastLoggedInAt : any;
    licenseId : any;
    settings: {};
    adbKeys : any;
    cookies: any;
    config: any;     // contains websocket url
    userObj: any;    // contains user info
    profileActiveStatus: boolean;
    loginMethod: string;
}